/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import DivisionSelectionV2 from './DivisionSelectionV2';

import { regStepIds } from '../../utils/eventConstants';
import { getRegisteredDoublesDivisions, updateRegistrationPartners } from '../../actions/event-profile-actions';

import styles from './eventRegForm.scss';

const ChangePartner = (props) => {
    const {
        user,
        event,
        clubVerificationFee,
        sidebarFlow,
        players,
    } = props;

    const { registeredDoublesDivisions, changePartnerUpdates } = useSelector(({ eventProfile }) => eventProfile);
    const [divisionsToDisplay, setDivisionsToDisplay] = useState();

    const dispatch = useDispatch();
    const isSwitchFlow = sidebarFlow === regStepIds.DIVISIONS_SWITCH;
    const isRegistered = event.registered || event.currentMember.isPlaying;

    const doesMemberExist = Object.values(players?.playersDict).some((player) => player.memberId === user?.id);
    const isIphone = /iPhone/i.test(navigator.userAgent);
    const isSafari = /Safari\/[0-9.]+/.test(navigator.userAgent) && !/Chrome|CriOS|Android|Edg|OPR/i.test(navigator.userAgent);

    useEffect(() => {
        if (!registeredDoublesDivisions.data) {
            dispatch(getRegisteredDoublesDivisions({ eventId: event.id }));
        }
    }, []);

    useEffect(() => {
        const updatedDivs = registeredDoublesDivisions.data?.map(regDiv => {
            if (changePartnerUpdates[regDiv.id]) {
                regDiv.player2 = changePartnerUpdates[regDiv.id].player2;
                regDiv.partnerDetails = null;
            }
            return regDiv;
        });
        setDivisionsToDisplay(updatedDivs);
    }, [registeredDoublesDivisions.data, changePartnerUpdates]);

    const onChangePartnerContinueClick = () => {
        const payload = {
            divisions: [],
        };
        Object.values(changePartnerUpdates).forEach(update => {
            payload.divisions.push(update.requestBody);
        });
        dispatch(updateRegistrationPartners({ eventId: event.id, payload }));
        props.handleCloseClick();
    };

    return (
        <>
            {!isSwitchFlow && isRegistered && (
                <>
                    {registeredDoublesDivisions.loading && (
                        <>Loading...</>
                    )}
                    {divisionsToDisplay?.map((division) => {
                        return (
                            <DivisionSelectionV2
                                key={`registered-division-${division.id || division.divisionId}`}
                                division={division}
                                event={event}
                                selected
                                shouldShowGenderInSubTitle={false}
                                shouldDisplayTeamPaymentType
                                shouldDisplayAgeRestrictionText={false}
                                shouldDisplayRangeRestrictionText={false}
                                disabled
                                hideCheckbox
                                clubVerificationFee={clubVerificationFee}
                                doesMemberExist={doesMemberExist}
                                userIsRegisteredToDivision
                                changePartnerFlow
                                toStep={props.toStep}
                            />
                        );
                    })}
                </>
            )}

            <div className={`${styles.divisionsSelectSummaryWrapper} ${isIphone ? styles.divisionsSelectSummaryWrapperIphone : ''} ${isSafari ? styles.divisionsSelectSummaryWrapperSafari : ''}`}>
                <button
                    data-test="divisionsSelectContinue"
                    type="button"
                    className="btn btn-primary btn-xl btn-block text-uppercase mb24"
                    disabled={!Object.keys(changePartnerUpdates).length}
                    onClick={onChangePartnerContinueClick}
                >
                    Continue
                </button>
            </div>
        </>
    );
};

ChangePartner.propTypes = {
    user: PropTypes.objectOf(any).isRequired,
    event: PropTypes.objectOf(any).isRequired,
    clubVerificationFee: PropTypes.number,
    players: PropTypes.objectOf(any).isRequired,
    handleCloseClick: PropTypes.func.isRequired,
    toStep: PropTypes.func.isRequired,
};

ChangePartner.defaultProps = {
    clubVerificationFee: 0,
};

export default ChangePartner;
